import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const importNotesApi = createApi({
  reducerPath: "importNotesApi",
  baseQuery,
  tagTypes: ["exportNotes"],
  endpoints: (builder) => ({


    createImportNotes: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `import/importNote/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { importNote: data },
      }),
      invalidatesTags: ["exportNotes"],
    }),


    // Updated Export Table

    updateImportNotes: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `import/importNote/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { importNote: data },
      }),
      invalidatesTags: ["exportNotes"],
    }),



    getNotesByImporterId: builder.query({
      query: ({ id }) => `import/importNote/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];
        return normalized.map((item) => ({
          ...item,
          id: item.importNoteId,
        }));
      },
      providesTags: ["exportNotes"],
    }),

    // 🔹 Get single invoice by Id
    getNotesById: builder.query({
      query: ({ id, subId }) =>
        `import/importNote/${id}/${subId}`,
      transformResponse: (response) => response?.data ?? null,


      providesTags: ["exportNotes"],
    }),

    deleteImportNote: builder.mutation({
      query: ({ id }) => ({
        url: `import/importNote/${id}`,
        method: "DELETE",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
      }),
      invalidatesTags: ["exportNotes"],
    }),


    fileUpload: builder.mutation({
      query: ({ file, token }) => {


        const formData = new FormData();
        formData.append("File", file);
     
        return {
          url: 'file-upload/upload',
          method: "POST",
          body: formData,
          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
            "Authorization": `Bearer ${token}`,
          },
        };
      },
      invalidatesTags: ["fileUpload"],
    }),
  })
});
export const {
  useCreateImportNotesMutation, 
  useUpdateImportNotesMutation,
  useLazyGetNotesByImporterIdQuery,
  useDeleteImportNoteMutation,
  useFileUploadMutation,

} = importNotesApi;


